import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledSelect = styled.select`
  display: block;
  width: 100%;
  border: 1px solid ${colours.elexonBlue};
  border-radius: 200px;
  height: auto;
  padding: 0.4rem 2.5rem 0.4rem 1rem;
  font-size: ${fonts.small};

  &:focus,
  &:active,
  &:hover {
    outline: none;
    box-shadow: none;
    border: 1px solid ${colours.elexonBlue};
  }

  &.invalid {
    border: 1px solid ${colours.elexonRed};
    padding-left: 33px;
  }
`;
